import {
  Preference,
  PreferenceActions,
  PreferenceSections,
} from 'utils/preferences';

const VAT_REPORT_REPORTING_CURRENCY_PREF_PREFIX = 'reportingCurrency';

function sanitizePreferenceKeyPart(value: string): string {
  return String(value ?? '')
    .trim()
    .replaceAll('-', '_');
}

export function reportingCurrencyPreferenceKey(
  connectionId: string,
  returnTypeId: string | number
): string {
  return `${VAT_REPORT_REPORTING_CURRENCY_PREF_PREFIX}_${sanitizePreferenceKeyPart(
    connectionId
  )}_${sanitizePreferenceKeyPart(String(returnTypeId))}`;
}

type VatReportPreferenceHandler = (
  action: PreferenceActions,
  preference: Preference
) => unknown;

export function resolveReportingCurrencyFromPreferences(
  handlePreferences: VatReportPreferenceHandler,
  connectionId: string,
  returnTypeId: string | number | undefined,
  fallbackCurrency: string | undefined,
  availableCurrencies: string[]
): string | undefined {
  if (!connectionId?.trim() || returnTypeId == null || returnTypeId === '') {
    return fallbackCurrency;
  }

  const saved = handlePreferences(PreferenceActions.GET, {
    name: reportingCurrencyPreferenceKey(connectionId, returnTypeId),
  });

  if (
    typeof saved === 'string' &&
    availableCurrencies.includes(saved)
  ) {
    return saved;
  }

  return fallbackCurrency;
}

export function saveReportingCurrencyPreference(
  handlePreferences: VatReportPreferenceHandler,
  connectionId: string,
  returnTypeId: string | number,
  currency: string
): void {
  if (!connectionId?.trim() || returnTypeId == null || returnTypeId === '' || !currency) {
    return;
  }

  handlePreferences(PreferenceActions.SET, {
    name: reportingCurrencyPreferenceKey(connectionId, returnTypeId),
    value: currency,
  });
}

export { PreferenceSections };
